export enum NotificationTemplateType {
  ClientSubscriptionSignUpSuccessful = 1,
  ClientSubscriptionSignUpFailed = 2,
  ClientBirthdayWish = 3,
  ClientSignUpLink = 7,
  ClientInvoiceCreatedPDF = 8,
  ClientPaymentCompletedPDF = 9,
  ClientCompletedWaiverPDF = 10,
  Feedback = 11,
  ClientRenewalReminder = 12,
  ClientIrregularNotification = 13,
  ClientSubscriptionActivation = 14,
  ClientAppResetPassword = 15,
  RequestAccess = 16, //Need to develop the functionality
  ClientProspectCreation = 17,
  ClientTransferorConcentApprovalLink = 19,
  ClientSalesReturnPDF = 20,
  ClientRefundPDF = 21,
  Other = 22,
}

export enum NotificationPreference {
  AllCheckins = 1,
  CheckinsWithBalance = 2,
  CheckinsWithSubscriptionScheduledCancellation = 3,
  Weblead = 4,
  NewSignupInitiated = 5,
  SignUpSuccess = 6,
  SignupPaymentFailed = 7,
  IncomingSMS = 8,
  IncomingEmail = 9,
  IncomingWhatsApp = 10
}

export enum NotificationGlobalVariables
{
    TenantName,
    TenantEmailId,
    TenantMobileNo,
    TenantAddress,
    ClientId,
    ClientName,
    ClientEmailId,
    ClientMobileNo,
    ClientMobileCountryCode,
    ClientPromotionalNotificationChannelsAllowed,
    ClientPreferredLanguage,
    ClientRepId,
    ClientLifeTimeValue,
    ClientStatus,
    ClientTotalOutstandingAmount,
    ClientSubStatus,
    ClientPassword,
    StaffName,
    StaffEmailId,
    StaffMobileNo,
    SubscriptionId,
    SubscriptionUUID,
    SubscriptionName,
    SubscriptionRecurringAmount,
    SubscriptionNextBillingDate,
    SubscriptionStartDate,
    SubscriptionEndDate,
    SubscriptionMinimumCommitmentUntil,
    SubscriptionCategory,
    PaymentAmount,
    PaymentDate,
    InvoiceAmount,
    InvoiceBalanceAmount,
    InvoiceSalesRepId,
    InvoiceUUID,
    InvoiceIssueDate,
    InvoicePrefix,
    Currency,
    ClientWaiverURL,
    ProspectCreatedDate,
    TransferShortLink,
    RecurringAppointmentStartDate,
    RecurringAppointmentStartTime,
    RecurringAppointmentRule,
    RecurringAppointmentNewStartDate,
    RecurringAppointmentNewStartTime,
    RecurringAppointmentOldStartDate,
    RecurringAppointmentOldStartTime,
    AppointmentCoachName,
    AppointmentCategoryName,
    AppointmentOldStartDateTime,
    AppointmentNewStartDateTime,
    AppointmentStartDateTime,
    AppointmentAvailableSessions,
    AppointmentTotalSessions,
    CancellationScheduledDate,
    ReactivationURL,
    PurchasePortalURL,
    WebsiteURL,
    ClassName,
    ClassDate,
    ClassTime,
    ClassCoachName,
    ClassCategoryName,
    ClientMembershipId,
    ClientMembershipStartDate,
    ClientMembershipEndDate,
    ClientMembershipName,
    ProspectEffectiveId, 
    ProspectEffectiveDate,
    ShortLink,
    FullLink,
    ClientsubscriptionCancelIsRevoked,
    ClientsubscriptionCancelScheduledDate,
    ClientsubscriptionCancelReason,
    ClientsubscriptionCancelCreatedDate,
    ClientTrialStartDate,
    ClientTrialMaxTrialClass,
    ClientTrialMaxTrialAppt,
    ClientTrialMaxTrialValidity,
    ClientTrialOwnerId,
    ClientTrialEndDate,
    FreezeStartdate,
    FreezeEnddate,
    FreezeStatus,
    TourDate,
    TourTime,
    TourPriority,
    TourTransactionLogDate,
    TourTransactionOutcome,
    TourTransactionPriority,
    TourStaffId,
    PaymentSalesRepId,
    RefundPaymentSalesRepId,
    SalesReturnSalesRepId,
    TaskAssignedToStaffId,
    AppointmentCoachId,
    ClassCoachId,
    ClientSubscriptionSalesRepId,
    ClientMembershipSessionOwnerId
}

export enum AudienceSourceDataType {
  Prospect = 1,
  ActiveClient = 2,
  ActiveClientWithoutPt = 3,
  ExpiredClient = 4,
  ExpiredClientGreaterThan90 = 5,
  BlackListed = 20,
}

export enum AudienceIntegrationType {
  FaceBook = 1,
  Twillo = 2,
}

export enum SMSAPIAuthorizationType
{
    None = 1,
    Basic = 2,
    Bearer = 3,
    Custom = 4,
    ApiKey = 5
}

export enum SMSAPIPayloadType
{
    Json = 2,
    QueryString = 3,
    FormUrlEncoded = 4
}

